// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hc1Q","clinicsSelect":"styles_clinicsSelect__PLJPE"};